import script from "./DefaultSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./DefaultSelect.vue?vue&type=script&setup=true&lang=ts"

import "./DefaultSelect.vue?vue&type=style&index=0&id=1c768bcc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c768bcc"]])

export default __exports__